import React from "react"
import { User } from "../../ZeefTypes"

interface UserListProps {
  title: string
  users: User[]
  isLoading: boolean
  onlineUsers: Set<string>
  showUnfollow?: boolean
  onUnfollow?: (userId: string) => void
  isUnfollowing?: boolean
  unfollowingUserId?: string | null
}

const UserList: React.FC<UserListProps> = ({
  title,
  users,
  isLoading,
  onlineUsers,
  showUnfollow = false,
  onUnfollow,
  isUnfollowing = false,
  unfollowingUserId = null,
}) => (
  <div className="follow-section">
    <h5>
      {title} ({users.length})
    </h5>
    <div className="user-list">
      {users.map((user) => (
        <div key={user.id} className="user-item">
          <div className="user-avatar-small">{user.username.substring(0, 2).toUpperCase()}</div>
          <div className="user-details-small">
            <div className="user-name-small">
              {user.username}
              {onlineUsers.has(user.id) && <span className="online-indicator"></span>}
            </div>
            <div className="user-email-small">{user.email}</div>
          </div>
          {showUnfollow && onUnfollow && (
            <div className="unfollow-btn" onClick={() => onUnfollow(user.id)} title="Unfollow user">
              {isUnfollowing && unfollowingUserId === user.id ? "..." : "−"}
            </div>
          )}
        </div>
      ))}
      {isLoading && <div className="loading-item">Loading...</div>}
    </div>
  </div>
)

export default UserList
